import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/metha/İndirilenler/starbucksweb/src/app/barista-dashboard/components/BaristaClient.tsx");
